(function() {
    'use strict';

    angular
        .module('skillsApp')
        .factory('documentLinkResolverService', documentLinkResolverService);

    /**
    * Resolves special urls, lets normal urls pass through
    */
    function documentLinkResolverService($http) {
        return {
            linkClicked: linkClicked
        };

        function linkClicked(doc, ev) {
            if (doc.isAsset) {
                ev.preventDefault();
                return $http.get(doc.link, {
                    responseType: "arraybuffer"
                }).then(response => {
                    var filename = response.headers('file-name');
                    var contentType = response.headers('content-type') || 'application/octet-stream';

                    var blob = new Blob([response.data], { type: contentType });
                    saveAs(blob, filename);
                });
            }
        }
    }
})();
